<script>
	import { currencyFormatter } from '../lib/utils';
	import { orderStore } from '../stores/order.store';
	export let id;
	$: order = $orderStore.find((order) => String(order.id) === String(id));
	$: total = order?.items?.reduce(
		(acc, item) => acc + item.price * item.quantity,
		0
	);
	$: {
		console.log({ order });
	}
</script>

<section class="section container">
	<h1>
		Order
		{order?.orderNumber}
	</h1>
	<br />
	<br />
	<div class="customer-info">
		<h2 style="margin-bottom:20px">Customer Information</h2>
		<div class="info-row">
			<span class="info-label">Name:</span>
			<span id="name" class="info-value">
				{order?.name}
			</span>
		</div>
		<div class="info-row">
			<span class="info-label">Phone:</span>
			<span id="phone" class="info-value">
				{order?.phone}
			</span>
		</div>
		<div class="info-row">
			<span class="info-label">Address:</span>
			<span id="address" class="info-value">
				{`${order?.address}, ${order?.city}, ${order?.country}, ${order?.postal}`}
			</span>
		</div>
	</div>
	<div class="order-summary">
		<h4>Items</h4>
		<br />
		<table>
			<thead>
				<tr>
					<th>Product</th>
					<th>Quantity</th>
					<th style="text-align: right;">Price</th>
				</tr>
			</thead>
			<tbody>
				{#each order.items as item}
					<tr>
						<td>
							<div style="display:flex;align-items:center">
								<img
									src={`/${item.imgSrc}`}
									style="height: 60px; width:60px;object-fit: cover;margin-right:10px;"
									alt=""
								/>
								<span>{item.name} </span>
							</div>
						</td>
						<td>
							{item.quantity}
						</td>
						<td style="text-align: right;">
							{currencyFormatter.format(item.price * item.quantity)}
						</td>
					</tr>
				{/each}
			</tbody>
		</table>
		<div style="display:flex;justify-content:flex-end">
			<span style="font-size: 18px;font-weight:bold;"
				>Total : {currencyFormatter.format(total)}
			</span>
		</div>
	</div>
</section>

<style>
	h1,
	h2 {
		text-align: center;
	}
	.order-summary table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: 20px;
	}
	.order-summary th,
	.order-summary td {
		padding: 10px;
		text-align: left;
	}
	.order-summary th {
		background-color: #8e8e8e;
	}
	.customer-info {
		margin-bottom: 20px;
	}
	.info-row {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}
	.info-label {
		width: 120px;
		font-weight: bold;
	}
	.info-value {
		flex-grow: 1;
	}
	th,
	td {
		text-align: left;
		border-bottom: 1px solid #ddd;
	}
</style>
